export default __webpack_public_path__ + "static/media/promo_04.2165afe7.jpg";